import memoizeOne from 'react-utils/memoizeOne';

export const getPortalId = memoizeOne((): number | undefined => {
  const portalIdArray = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.exec(
    document.location.pathname
  );

  const currentWindow = window;
  const portalId =
    portalIdArray && portalIdArray.length > 1
      ? Number(portalIdArray[1])
      : (currentWindow as any).hubspot !== undefined &&
        (currentWindow as any).hubspot.portal !== undefined
      ? (currentWindow as any).hubspot.portal.id
      : undefined;

  return portalId;
});

export const clearPortalIdCache = () => {
  getPortalId.resetCache();
};
